function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable max-lines */
/* eslint-disable max-statements */
import React, { useEffect, useMemo, useState } from 'react';

import {

  useLoaderData,
  useLocation,
  useNavigate,
  useRevalidator,
  useSearchParams } from
'react-router-dom';

import { useSetAtom } from 'jotai';
import * as extractorsAPI from "../../../api/ix/extractors";
import * as suggestionsAPI from "../../../api/ix/suggestions";
import * as templatesAPI from "../../../api/templates";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";

import { Button, PaginationState, Paginator, Table } from "../../../Components/UI";
import { Translate } from "../../../../I18N";


import { notificationAtom } from "../../../atoms";

import { socket } from "../../../../socket";
import { SuggestionsTitle } from "./components/SuggestionsTitle";
import { FiltersSidepanel } from "./components/FiltersSidepanel";
import { suggestionsTableColumnsBuilder } from "./components/TableElements";
import { PDFSidepanel } from "./components/PDFSidepanel";
import { updateSuggestions, updateSuggestionsByEntity } from "./components/helpers";

const SUGGESTIONS_PER_PAGE = 100;
const SORTABLE_PROPERTIES = ['entityTitle', 'segment', 'currentValue'];









const ixmessages = {
  ready: 'Find suggestions',
  sending_labeled_data: 'Sending labeled data...',
  processing_model: 'Training model...',
  processing_suggestions: 'Finding suggestions...',
  cancel: 'Canceling...',
  error: 'Error'
};

const IXSuggestions = () => {var _status$data;
  const { suggestions, extractor, templates, aggregation, currentStatus, totalPages } =
  useLoaderData();








  const [currentSuggestions, setCurrentSuggestions] = useState(suggestions);
  useMemo(() => setCurrentSuggestions(suggestions), [suggestions]);

  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [sidepanel, setSidepanel] = useState('none');
  const [sidepanelSuggestion, setSidepanelSuggestion] = useState();
  const [selected, setSelected] = useState([]);
  const [sorting, setSorting] = useState([]);
  const { revalidate } = useRevalidator();
  const setNotifications = useSetAtom(notificationAtom);
  const [status, setStatus] = useState(



    { status: currentStatus });

  useEffect(() => {
    socket.on(
      'ix_model_status',
      (extractorId, modelStatus, _, data) => {
        if (extractorId === extractor._id) {
          setStatus({ status: modelStatus, data });
          if (data && data.total === data.processed || modelStatus === 'ready') {
            setStatus({ status: 'ready' });
            revalidate();
          }
        }
      }
    );

    return () => {
      socket.off('ix_model_status');
    };
  }, [extractor._id, revalidate]);

  useEffect(() => {
    if (searchParams.has('sort') && !sorting.length) {
      navigate(location.pathname, { replace: true });
    }

    if (sorting.length && sorting[0].id) {
      const property = sorting[0].id;

      if (!SORTABLE_PROPERTIES.includes(property)) {
        return;
      }

      const order = sorting[0].desc ? 'desc' : 'asc';

      navigate(`${location.pathname}?sort={"property":"${property}","order":"${order}"}`, {
        replace: true
      });
    }
  }, [sorting]);

  const filteredTemplates = () =>
  templates ? templates.filter((template) => extractor.templates.includes(template._id)) : [];

  const acceptSuggestions = async (acceptedSuggestions) => {
    try {
      await suggestionsAPI.accept(
        acceptedSuggestions.map((acceptedSuggestion) => ({
          _id: acceptedSuggestion._id,
          sharedId: acceptedSuggestion.sharedId,
          entityId: acceptedSuggestion.entityId
        }))
      );
      setCurrentSuggestions(updateSuggestions(currentSuggestions, acceptedSuggestions));
      setNotifications({
        type: 'success',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Suggestion accepted.")
      });
    } catch (error) {var _error$json;
      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred"),
        details: (_error$json = error.json) !== null && _error$json !== void 0 && _error$json.prettyMessage ? error.json.prettyMessage : undefined
      });
    }
  };

  const trainModelOrCancelAction = async () => {
    try {
      if (status.status === 'ready') {
        setStatus({ status: 'sending_labeled_data' });
        const response = await suggestionsAPI.findSuggestions(extractor._id);
        setStatus(response);
      } else {
        await suggestionsAPI.cancel(extractor._id);
        if (status.status === 'error') {
          setStatus({ status: 'ready' });
        } else {
          setStatus({ status: 'cancel' });
        }
        revalidate();
      }
    } catch (error) {}
  };

  const openPDFSidepanel = (selectedSuggestion) => {
    setSidepanelSuggestion(selectedSuggestion);
    setSidepanel('pdf');
  };

  const closeSidepanel = () => {
    setSidepanel('none');
  };

  return /*#__PURE__*/(
    _jsx("div", {
      className: "tw-content",
      "data-testid": "settings-ix",
      style: { width: '100%', overflowY: 'auto' } }, void 0, /*#__PURE__*/

    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, {
      path: new Map([['Metadata extraction', '/settings/metadata_extraction']]),
      title: extractor.name }
    ), /*#__PURE__*/

    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx(Table, {
      data: currentSuggestions,
      columns: suggestionsTableColumnsBuilder(
        filteredTemplates(),
        acceptSuggestions,
        openPDFSidepanel
      ),
      title: /*#__PURE__*/
      _jsx(SuggestionsTitle, {
        property: extractor.property,
        templates: filteredTemplates(),
        onFiltersButtonClicked: () => {
          setSidepanel('filters');
        } }
      ),

      enableSelection: true,
      sorting: sorting,
      setSorting: setSorting,
      onSelection: setSelected,
      footer: /*#__PURE__*/
      _jsx("div", { className: "flex justify-between h-6" }, void 0, /*#__PURE__*/
      _jsx(PaginationState, {
        page: Number(searchParams.get('page') || 1),
        size: SUGGESTIONS_PER_PAGE,
        total: ((_status$data = status.data) === null || _status$data === void 0 ? void 0 : _status$data.total) || totalPages * SUGGESTIONS_PER_PAGE,
        currentLength: currentSuggestions.length }
      ), /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(Paginator, {
        totalPages: totalPages,
        currentPage: searchParams.has('page') ? Number(searchParams.get('page')) : 1,
        buildUrl: (page) => {
          const innerSearchParams = new URLSearchParams(location.search);
          innerSearchParams.delete('page');
          innerSearchParams.set('page', page);
          return `${location.pathname}?${innerSearchParams.toString()}`;
        } }
      )
      )
      ) }

    )
    ), /*#__PURE__*/

    _jsx(SettingsContent.Footer, { className: `flex gap-2 ${selected.length ? 'bg-gray-200' : ''}` }, void 0,
    selected.length ? /*#__PURE__*/
    _jsx("div", { className: "flex justify-center items-center space-x-4" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      size: "small",
      type: "button",
      styling: "outline",
      onClick: async () => {
        await acceptSuggestions(
          selected.map((selectedSuggestion) => selectedSuggestion.original)
        );
      } }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Accept suggestion")
    ), /*#__PURE__*/
    _jsx("div", { className: "text-sm font-semibold text-center text-gray-900" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "font-light text-gray-500" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Selected")
    ), "\xA0",

    selected.length, "\xA0", /*#__PURE__*/

    _jsx("span", { className: "font-light text-gray-500" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "of")
    ), "\xA0",

    SUGGESTIONS_PER_PAGE
    )
    ) : /*#__PURE__*/

    _jsx("div", { className: "flex justify-center items-center space-x-4" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      size: "small",
      type: "button",
      disabled: status.status === 'cancel',
      styling: status.status === 'ready' ? 'solid' : 'outline',
      onClick: trainModelOrCancelAction }, void 0,

    status.status === 'ready' ? /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Find suggestions") : /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Cancel")

    ),
    status.status !== 'ready' ? /*#__PURE__*/
    _jsx("div", { className: "text-sm font-semibold text-center text-gray-900" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, ixmessages[status.status]),
    status.message && status.status === 'error' ? ` : ${status.message}` : '',
    status.data ? /*#__PURE__*/
    _jsx("span", { className: "ml-2" }, void 0,
    status.data.processed, " / ", status.data.total
    ) :
    null
    ) :
    null
    )

    )
    ), /*#__PURE__*/

    _jsx(FiltersSidepanel, {
      showSidepanel: sidepanel === 'filters',
      setShowSidepanel: closeSidepanel,
      aggregation: aggregation }
    ), /*#__PURE__*/

    _jsx(PDFSidepanel, {
      showSidepanel: sidepanel === 'pdf',
      setShowSidepanel: closeSidepanel,
      suggestion: sidepanelSuggestion,
      onEntitySave: (updatedEntity) =>
      setCurrentSuggestions(updateSuggestionsByEntity(currentSuggestions, updatedEntity)) }

    )
    ));

};

const IXSuggestionsLoader =
(headers) =>
async ({ params: { extractorId }, request }) => {
  if (!extractorId) throw new Error('extractorId is required');
  const searchParams = new URLSearchParams(request.url.split('?')[1]);
  const filter = { extractorId };
  if (searchParams.has('filter')) {
    filter.customFilter = JSON.parse(searchParams.get('filter'));
  }

  const sortingOption = searchParams.has('sort') ? searchParams.get('sort') : undefined;

  const suggestionsList =
  await suggestionsAPI.get(_objectSpread({

    filter,
    page: {
      number: searchParams.has('page') ? Number(searchParams.get('page')) : 1,
      size: SUGGESTIONS_PER_PAGE
    } },
  sortingOption && { sort: JSON.parse(sortingOption) }),

  headers
  );

  const extractors = await extractorsAPI.getById(extractorId, headers);
  const aggregation = await suggestionsAPI.aggregation(extractorId, headers);
  const currentStatus = await suggestionsAPI.status(extractorId, headers);
  const templates = await templatesAPI.get(headers);
  return {
    suggestions: suggestionsList.suggestions,
    totalPages: suggestionsList.totalPages,
    extractor: extractors[0],
    templates,
    aggregation,
    currentStatus: currentStatus.status
  };
};

export { IXSuggestions, IXSuggestionsLoader };